// Tooltip theme constants
export const TOOLTIP_THEME = {
  LIGHT: 'light',
  DARK: 'dark'
} as const;

// Tooltip arrow direction constants
export const TOOLTIP_ARROW = {
  NONE: 'none',
  TOP_CENTER: 'top-center',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  LEFT: 'left',
  RIGHT: 'right'
} as const;

export type TooltipArrow = typeof TOOLTIP_ARROW[keyof typeof TOOLTIP_ARROW];
